import { useState } from 'react';

export const Validations = {
  isEmpty: (value, message = 'This field cannot be empty') => {
    if (/^\s*$/.test(value)) {
      return message;
    }
    return null;
  }
}

export const useFormValidation = (initialValues, validationRules) => {
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value, checked, type } = event.target;
    const newValue = type === 'checkbox' ? checked : value;
    setValues(prevValues => ({ ...prevValues, [name]: newValue }));
    setErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
  };

  const validate = () => {
    return Object.entries(validationRules).reduce((acc, [name, rules]) => {
      const currentValue = values[name];
      const errorMessage = rules.reduce((error, rule) => error || rule(currentValue), null);
      return errorMessage ? { ...acc, [name]: errorMessage } : acc;
    }, {});
  };

  const isValid = () => {
    const newErrors = validate();
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (callback) => (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    if (isValid()) {
      callback(values);
    }
    setIsSubmitting(false);
  };

  return {
    values,
    errors,
    isSubmitting,
    handleChange,
    handleSubmit,
    setValues,
    setErrors,
  };
};
